import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ApiService } from '../../core/services/api.service';
import Swal from 'sweetalert2';
import { RoleService } from "../../core/services/role.service";
import { SocketService } from '../../core/services/socket.service';
import { Subscription } from 'rxjs';
import {NgbModal,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-vehicle-list',
  templateUrl: './vehicle-list.component.html',
  styleUrls: ['./vehicle-list.component.scss'],
  standalone: false
})
export class VehicleListComponent implements OnInit, OnDestroy {
  @ViewChild('statusModal') statusModal: any;

  statusModalRef: NgbModalRef | null = null;

  selectedVehicle: any = null;

  selectedVehicleStatus: string = 'all';
  selectedStatusForModal: string = '';
  statusRemark: string = '';
  statusSubmitting = false;

  vehicleStatusOptions = [
    {
      value: 'available',
      label: 'Available'
    },
    // {
    //   value: 'breakdown',
    //   label: 'Breakdown'
    // },
    {
      value: 'maintenance',
      label: 'Maintenance'
    },
    {
      value: 'preparing',
      label: 'Preparing'
    },
    {
      value: 'on_special_duty',
      label: 'On Special Duty'
    },
    {
      value: 'other',
      label: 'Other'
    }
  ];

  Math = Math;
  vehicles: any[] = [];
  displayVehicles:any[] =[];
  loading = false;
  error: string | null = null;
  
  fireStations: any[] = [];

  // Filter options
  incidentStatus: string[] = ['available','assigned','maintenance','preparing','on_special_duty','other'];
  selectedFireStationId: number | null = null;
  
  // Selected filters
  selectedStatus: string | null = null;
  
  
  loadingFilters = false;
  private socketSubscriptions: Subscription[] = [];

  constructor(
    private apiService: ApiService, 
    public roleService: RoleService,
    private socketService: SocketService,
    private modalService: NgbModal
  ) {}

  ngOnInit(): void {
    this.loadVehicles();
    this.loadFilterOptions();
  }

  loadFilterOptions(): void {
    this.loadingFilters = true;
    
    this.apiService.get('/fire-stations').subscribe({
      next: (response: any) => {
        this.fireStations = response.data || [];
      },
      error: (error) => console.error('Error loading fire stations:', error)
    });
  }

  openStatusModal(vehicle: any): void {
    if (vehicle.availabilityStatus === 'assigned') {
      Swal.fire({
        icon: 'warning',
        title: 'Status Cannot Be Changed',
        text: 'This vehicle is currently assigned to an incident.',
        confirmButtonColor: '#B71C1C'
      });

      return;
    }

    this.selectedVehicle = vehicle;

    // Popup me current vehicle status selected rahega
    const currentStatus = vehicle.availabilityStatus;

    this.selectedStatusForModal =
      this.vehicleStatusOptions.some(
        status => status.value === currentStatus
      )
        ? currentStatus
        : '';

    this.statusRemark = vehicle.unavailabilityReason || '';
    this.statusSubmitting = false;

    this.statusModalRef = this.modalService.open(this.statusModal, {
      centered: true,
      size: 'md',
      backdrop: 'static',
      keyboard: false
    });
  }

  closeStatusModal(): void {

    if (this.statusModalRef) {
      this.statusModalRef.close();
      this.statusModalRef = null;
    }

    this.selectedVehicle = null;
    this.selectedVehicleStatus = 'all';
    this.selectedStatusForModal = '';
    this.statusRemark = '';
  }

  submitVehicleStatus(): void {

    if (!this.selectedVehicle) {
      return;
    }

    this.statusSubmitting = true;

    const payload = {
      availabilityStatus: this.selectedStatusForModal,
      unavailabilityReason: this.statusRemark?.trim() || null
    };

    const vehicleId = this.selectedVehicle.id;

    this.apiService.post(
      `/fims-vehicles/${vehicleId}/availability`,
      payload
    ).subscribe({

      next: (response: any) => {

        this.statusSubmitting = false;

        if (response.success !== false) {

          Swal.fire({
            icon: 'success',
            title: 'Status Updated',
            text: 'Vehicle availability status has been updated successfully.',
            confirmButtonColor: '#B71C1C'
          });

          this.closeStatusModal();

          // Refresh vehicle list
          this.loadVehicles();

        } else {

          Swal.fire({
            icon: 'error',
            title: 'Update Failed',
            text: response.message || 'Unable to update vehicle status.',
            confirmButtonColor: '#B71C1C'
          });

        }
      },

      error: (error) => {

        this.statusSubmitting = false;

        console.error('Vehicle availability update error:', error);

        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error?.error?.message ||
                error?.error?.error ||
                'Unable to update vehicle status.',
          confirmButtonColor: '#B71C1C'
        });

      }

    });
  }

  loadVehicles(): void {
  this.loading = true;
  this.error = null;

  const url = this.buildFilterUrl();

  this.apiService.get(url).subscribe({
    next: (response: any) => {

      this.vehicles = response.data?.data || response.data || [];

      this.loading = false;
    },

    error: (error) => {
      this.error = 'Failed to load vehicles. Please try again.';
      this.loading = false;

      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Unable to load vehicles. Please refresh the page.',
        confirmButtonColor: '#405189'
      });
    }
  });
}
  
  buildFilterUrl(): string {
    let params: string[] = [];
    
    if (this.selectedVehicleStatus && this.selectedVehicleStatus !== 'all') {
      params.push(`status=${this.selectedVehicleStatus}`);
    }

    if (this.selectedFireStationId) {
      params.push(`fire_station_id=${this.selectedFireStationId}`);
    }
    
    return `/fims-vehicles?${params.join('&')}`;
  }


  refreshIncidents(): void {
    this.resetFilters();
    this.loadVehicles();
  }
  
  resetFilters(): void {
    this.selectedVehicleStatus = 'all';
    this.selectedFireStationId = null;
  }

  ngOnDestroy(): void {
  }


applyFilters(): void {
  this.loadVehicles();
}

}
